var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagicStick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 11.6665L8.83321 9.1665M13.0085 2.9165V1.6665M16.2913 4.21705L17.1752 3.33317M16.2913 10.8332L17.1752 11.7171M9.67517 4.21705L8.79128 3.33317M17.5918 7.49984H18.8418M5.60935 17.3904L13.3071 9.69265C13.6371 9.36263 13.8021 9.19763 13.8639 9.00735C13.9183 8.83998 13.9183 8.65969 13.8639 8.49232C13.8021 8.30205 13.6371 8.13704 13.3071 7.80703L12.6927 7.19265C12.3627 6.86263 12.1977 6.69763 12.0074 6.6358C11.84 6.58142 11.6597 6.58142 11.4924 6.6358C11.3021 6.69763 11.1371 6.86263 10.8071 7.19265L3.10935 14.8904C2.77934 15.2204 2.61433 15.3854 2.5525 15.5757C2.49812 15.743 2.49812 15.9233 2.5525 16.0907C2.61433 16.281 2.77934 16.446 3.10935 16.776L3.72373 17.3904C4.05375 17.7204 4.21875 17.8854 4.40903 17.9472C4.5764 18.0016 4.75669 18.0016 4.92405 17.9472C5.11433 17.8854 5.27934 17.7204 5.60935 17.3904Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicStick);
export default __webpack_public_path__ + "static/media/magicStick.ba4b16dc1c57095b8b8b73050a53a1c2.svg";
export { ForwardRef as ReactComponent };